<template>
<div class="fixed inset-0 z-20 flex justify-end bg-black opacity-90
  md:w-full">
  <on-click-outside :handler="closeMenu">
  <div class="flex flex-col shadow-2xl bg-white uppercase tracking-wider
    p-12 md:w-80 h-1/2 md:h-screen text-lg font-sans-serif">
    <button @click="closeMenu" class="transform
      hover:text-beige-academy-250 self-end text-orange-academy-300">
      <close-icon class="" />
    </button>
    <nav class="flex h-full flex-col justify-around shadowColor
      my-8 text-xl pb-20 font-light divide-y-2 md:divide-y-0 bg-white">
      <router-link to="/" class="mt-20 hover:text-beige-academy-250 w-full
        px-12 py-8 flex justify-start md:justify-center text-orange-academy-300
        hover:font-bold"
        @click.native="closeMenu" :class="$route.fullPath === '/' ?
        'w-full text-left bg-white' : ''"
           >
          Home
      </router-link>
      <router-link to="/teachers" class="hover:text-beige-academy-250 w-full
        px-12 py-8 flex justify-start md:justify-center text-orange-academy-300
        hover:font-bold"
        @click.native="closeMenu" :class="$route.fullPath === '/teachers' ?
        'w-full text-left bg-white' : ''">
          {{$t('menu.teachers')}}
      </router-link>
      <router-link to="/masterclasses" class="hover:text-beige-academy-250 w-full
        px-12 py-8 flex justify-start md:justify-center text-orange-academy-300
        hover:font-bold"
        @click.native="closeMenu" :class="$route.fullPath === '/masterclasses' ?
        'w-full text-left bg-white' : ''">
          Masterclasses
      </router-link>
      <!--<router-link to="/courses" class="hover:bg-white w-full px-12 py-8 flex justify-center"
        @click.native="closeMenu" :class="$route.fullPath === '/courses' ?
        'font-semibold w-full text-left bg-white' : ''">
          {{$t('menu.courses')}}
      </router-link>
      <router-link to="/instruments" class="hover:bg-white w-full px-12 py-8 flex justify-center"
        @click.native="closeMenu" :class="$route.fullPath === '/instruments' ?
        'font-semibold w-full text-left bg-white' : ''">
          {{$t('menu.musical-instruments')}}
      </router-link>-->
    </nav>
  </div>
  </on-click-outside>
</div>
</template>

<script>
import CloseIcon from '@/components/graphics/CloseIcon.vue';
import supportedLocales from '@/util/i18n/supported-locales';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import dayjs from 'dayjs';
import OnClickOutside from '@/directives/OnClickOutside';

import { mapActions, mapGetters } from 'vuex';

export default {
  props: ['value'],

  components: {
    CloseIcon,
    OnClickOutside,
  },

  data() {
    return {
      locales: supportedLocales.getSupportedLocales(),
    };
  },

  mixins: [StreamFunctionsMixin],

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      localTimezone: 'timezone/localTimezone',
      choosenTimezone: 'timezone/choosenTimezone',
    }),
  },

  created() {
    this.setLocalTimezone();
    this.checkAuthenticationToSetTimezone();
  },

  watch: {
    authenticated() {
      if (!this.authenticated) {
        this.setChoosenTimezone(this.localTimezone);
        dayjs.tz.setDefault(this.choosenTimezone);
      }
    },
  },

  methods: {
    ...mapActions({
      signOut: 'auth/SignOut',
      setLocalTimezone: 'timezone/setLocalTimezone',
      setChoosenTimezone: 'timezone/setChoosenTimezone',
    }),

    logout() {
      this.signOut().then(() => {
        this.closeMenu();
        this.createNotification('info', this.$t('notifications.logout'));
        this.$router.push({ name: 'Home' }).catch(() => {});
      });
    },

    checkAuthenticationToSetTimezone() {
      if (!this.authenticated) {
        this.setChoosenTimezone(this.localTimezone);
        dayjs.tz.setDefault(this.choosenTimezone);
      }
    },

    closeMenu() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss" scoped>
  a [aria-current=page] {
    border-bottom-color: #A69185;
    border-bottom-width: 0.1rem;
    font-size: 1.3rem;
  }
  .shadowColor {
   --tw-shadow: 0px 3px 8px 2px rgb(255, 255, 255),
    2px -1px 3px 1px rgb(255, 255, 255);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgb(255, 255, 255)),
    var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .blur {
    backdrop-filter: blur(10px) brightness(75%);
  }
</style>
